// https://en.wikipedia.org/wiki/International_System_of_Units#Base_units

/**
 * Enum for common colors.
 * @readonly
 * @enum {{name: string, hex: string}}
 */
export const UnitBaseTypes = Object.freeze({
  newton: "N",
  metre: "m",
  pascal: "Pa",
  // ----
  foot: "ft",
  inch: "in",
  kip: "kip",
  ksi: "ksi",
  ksf: "ksf",
  lb: "lb",
  psi: "psi",
  // ...
});

export function Unit({ unit, prefix, exponent }) {
  let modifiedUnit = unit.toString();
  if (prefix) {
    modifiedUnit = `${prefix}${unit}`;
  }

  if (exponent) {
    return (
      <>
        {modifiedUnit}
        <sup>{exponent}</sup>
      </>
    );
  }

  return <>{modifiedUnit}</>;
}
